const style: any = (): any => ({
	
    msLoginBtn : {
        display: "flex",
        alignItems: "center",
        // justifyContent: "center",
        backgroundColor: "#2F2F2F", 
        color: "white",
        border: "none",
        padding: "10px",
        fontWeight: 400,
        cursor: "pointer",
        transition: "background 0.3s ease",
        width: 250,
        "&:active" :{
            backgroundColor: "#1A1A1A"
        },
        "&: svg" : {
            width: "20px",
            height: "20px",
            marginRight: "10px"
        },
        "&:hover" :{
            backgroundColor: "#5E5E5E" /* Slightly lighter gray */
        }
      },
      alignContent:{
        diplay:"flex",
        alignItems:"center"
      },
      iconCss:{
        paddingRight:"12px",
        paddingLeft:"12px"
      },
      labelCss:{
        paddingRight:"12px",
        paddingBottom:"3px"
      }

});

export default style;